import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useField } from "react-final-form";

export const FIELD_NAME_ASSIGN_TO = "userId";

const tLabel = "Assign To";
const tNoAssignment = "Unassigned";

export interface Member {
  id: string;
  name: string;
}

export interface AssignToProps {
  members?: Member[];
  required?: boolean;
  name?: string;
  initialValue?: string;
  defaultValue?: string;
}

export const AssignTo = ({
  members = [],
  required,
  name = FIELD_NAME_ASSIGN_TO,
  initialValue,
  defaultValue = "",
}: AssignToProps) => {
  const { input } = useField(name, {
    initialValue: initialValue || defaultValue,
  });

  return (
    <FormControl fullWidth>
      <InputLabel id={`${name}-label`} required={required}>
        {tLabel}
      </InputLabel>
      <Select labelId={`${name}-label`} id={name} label={tLabel} {...input}>
        <MenuItem value="">{tNoAssignment}</MenuItem>
        {members.map((member) => (
          <MenuItem key={member.id} value={member.id}>
            {member.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
